import React, { useEffect, useRef, useState, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 数据源
import { ListStore } from '../../store';
// 秒数转时间格式
import { i2s } from '@src/utils/format';

// 拉端
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { setAppQueryNoIfengsp, setQuery } from '@src/utils/url';
import { message } from '@src/components/ModalBox';
// 统计
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import Observer from '@researchgate/react-intersection-observer';
import { Grounds } from '@ifeng-fe/client_grounds';
import { formatUrl, formatImage } from '@ifeng-fe/public_method';
import { devPath } from '@src/constants';
import { WxLaunchApp } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchApp/dynamic';

const Gags = ({ content }) => {
    const {
        params: { id },
    } = content;
    // 列表数据源
    const listStore = ListStore.useContainer();
    const { listStates, changeListStates } = listStore;
    const { currentVideo, dramaSeries, positive, gags } = listStates;
    const listScrollRef = useRef();
    const [tagIndex, setTagIndex] = useState();
    // 统计
    // page
    const sendPage = (
        videoId, // 视频id
        dramaSeriesId, // 剧集id
        index, // 从0开始
    ) => {
        pageStatistics({
            behavior: 'page',
            id: `video_${videoId}`,
            type: 'video',
            ref: `phmovie_${dramaSeriesId}`,
            reftype: 'editor|||||||',
            rnum: `6_${index}`,
            showtype: 'partgags',
            pagetag: '', // 手动clear
        });
    };
    // 曝光
    const handleObserverChange = (entry, unobserve, index) => {
        const { isIntersecting } = entry;

        if (isIntersecting) {
            const { base62Id } = gags[index];

            Grounds.expose({
                id: `video_${base62Id}`,
                rnum: `6_${index}`,
                reftype: 'editor|||||||', // 不加encodeURL
                ch: `phmovie_${dramaSeries.base62Id}`,
                src: '',
                showtype: 'partgags',
                pagetype: 'video',
            });
            // pageStatistics({
            //     behavior: 'pageinfo',
            //     id: `video_${base62Id}`,
            //     rnum: `6_${index}`,
            //     reftype: 'editor|||||||', // 不加encodeURL
            //     ch: `phmovie_${dramaSeries.base62Id}`,
            //     src: '',
            //     showtype: 'partgags',
            //     pagetype: 'video',
            // });
            unobserve();
        }
    };

    // 切换花絮
    const handleClickGags = (item, index, isJumpQQlink = false, isCallAppWx = true) => {
        if (!window.grounds) {
            console.log('拉端');
            // 替换id
            // const url = window.location.href;

            let finalUrl = '';
            const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

            // 分享正片
            if (positiveIndex > -1) {
                finalUrl = setAppQueryNoIfengsp(
                    `${devPath}/details/${
                        dramaSeries.base62Id
                    }?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${
                        currentVideo.base62Id
                    }`,
                );
            } else {
                // 分享花絮
                finalUrl = setAppQueryNoIfengsp(
                    `${devPath}/details/${
                        dramaSeries.base62Id
                    }?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`,
                );
            }

            if (isCallAppWx) {
                callApp({
                    docType: 'web',
                    pid: finalUrl,
                    kind: 'inter_da01',
                    noKindFrom: 1,
                    download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1512057577113',
                    downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8927',
                    isJumpQQlink
                });
            }

            return;
        }
        // UI
        setTagIndex(String(index));
        // 数据
        if (item.videoPlayUrl) {
            changeListStates({
                currentVideo: item,
            });
        } else {
            // 下线
            message({
                content: (
                    <div className={styles.success}>
                        <div className={styles.successText}>当前视频已下线</div>
                    </div>
                ),
            });
        }

        // 统计
        Grounds.pageStat({
            behavior: 'page',
            id: `video_${item.base62Id}`,
            type: 'video',
            ref: `phmovie_${dramaSeries.base62Id}`,
            reftype: 'editor|||||||',
            rnum: `6_${index}`,
            showtype: 'partgags',
            pagetag: '', // 手动clear
        });
        // sendPage(item.base62Id, dramaSeries.base62Id, index);
    };

    useEffect(
        () => {
            if (currentVideo.videoPlayUrl) {
                const index = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

                // 当前视频为正片
                if (index > -1) {
                    rollListLeft();
                }
            }
        },
        [currentVideo],
    );

    // 手动滚
    useEffect(
        () => {
            if (tagIndex && listScrollRef.current) {
                rollListMiddle();
            }
        },
        [tagIndex, listScrollRef],
    );
    // 自动滚
    useEffect(
        () => {
            if (currentVideo.videoPlayUrl && listScrollRef.current) {
                const autoIndex = gags.findIndex(item => item.base62Id === currentVideo.base62Id);

                // 当前视频为花絮

                if (autoIndex > -1) {
                    rollListMiddle(autoIndex);
                }
            }
        },
        [currentVideo],
    );
    // 列表滚动中间
    const rollListMiddle = autoIndex => {
        const index = autoIndex ?? tagIndex; // autoInde联播/tagIndex点击
        const listScroll = listScrollRef.current;
        const listChildNodes = listScroll.childNodes[0].childNodes;
        const current = listChildNodes[index];

        // 计算paddingLeft
        // const paddingLeft = parseFloat(getStyle(listScroll, 'paddingLeft'), 10);

        const listMiddle = Math.floor(parseInt(listScroll.clientWidth, 10) / 2);
        const tagMiddle = current.offsetWidth / 2;
        // 排除第一项

        if (String(index) === '0') {
            return (listScroll.scrollLeft = 0);
        }
        if (current.offsetLeft + tagMiddle > listMiddle) {
            listScroll.scrollLeft = Math.floor(current.offsetLeft - listMiddle + current.offsetWidth / 2);
        } else {
            listScroll.scrollLeft = Math.floor(listMiddle - current.offsetLeft - current.offsetWidth / 2);
        }
    };
    // 列表滚动最左
    const rollListLeft = () => {
        const listScroll = listScrollRef.current;

        listScroll.scrollLeft = 0;

        return;
    };

    const SchemeLink = () => {
        let finalUrl = '';
        const positiveIndex = positive.findIndex(item => item.base62Id === currentVideo.base62Id);

        // 分享正片
        if (positiveIndex > -1) {
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=positive&positiveId=${
                    currentVideo.base62Id
                }`,
            );
        } else {
            // 分享花絮
            finalUrl = setAppQueryNoIfengsp(
                `${devPath}/details/${
                    dramaSeries.base62Id
                }?id=phmovie&ref=outside&type=other&backIndex=true&source=gags&gagsId=${currentVideo.base62Id}`,
            );
        }

        return getSchemeLink({
            docType: 'web',
            pid: finalUrl,
            kind: 'inter_da01',
            noKindFrom: 1
        });
    };

    return (
        <div id="listWrapGags">
            {gags && gags.length ? (
                <div className={styles.wrap}>
                    <div className={styles.title}>片段花絮</div>
                    <div className={styles.listWrap}>
                        <div className={styles.listScroll} ref={listScrollRef}>
                            <div className={styles.listContent}>
                                {gags && gags.length
                                    ? gags.map((item, index) => {
                                          const { title, thumbnails, duration } = item;
                                          const { image } = thumbnails;

                                          return (
                                              <Observer
                                                  onChange={(entry, unobserve) =>
                                                      handleObserverChange(entry, unobserve, index)
                                                  }
                                                  key={index}>
                                                  <div className={`${styles.itemWrap} ${currentVideo.base62Id === item.base62Id ? styles.current : ''}`} onClick={() => handleClickGags(item, index)}>
                                                      <div className={styles.itemImgWrap}>
                                                          {duration ? (
                                                              <>
                                                                  <div className={styles.mask} />
                                                                  <div className={styles.itemDuration}>
                                                                      {i2s(duration)}
                                                                  </div>
                                                              </>
                                                          ) : null}

                                                          {!window.grounds ? (
                                                              <div className={styles.groundsTitle}>APP内播放</div>
                                                          ) : null}

                                                          <img
                                                              className={styles.itemImg}
                                                              //   src={image[0].url}
                                                              src={formatImage(image[0].url, 264, 175)}
                                                          />
                                                      </div>

                                                      <div className={styles.itemContent}>{title}</div>
                                                      {
                                                          !window.grounds &&
                                                          <WxLaunchApp
                                                              launchType="app"
                                                              launchAppClick={() => handleClickGags(item, index, false, false)}
                                                              schemeLink={SchemeLink()}
                                                              launchAppFail={() => handleClickGags(item, index, true, true)}
                                                          />
                                                      }
                                                  </div>
                                              </Observer>
                                          );
                                      })
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
};

Gags.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Gags);
